(function () {
  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function addTileLayer(map, tileStyle, jawgToken) {
    if (tileStyle === 'jawg_streets' && jawgToken) {
      L.tileLayer('https://{s}.tile.jawg.io/jawg-streets/{z}/{x}/{y}{r}.png?access-token=' + encodeURIComponent(jawgToken), {
        minZoom: 0,
        maxZoom: 22,
        subdomains: 'abcd',
        attribution: '<a href="https://jawg.io" target="_blank" rel="noopener">&copy; Jawg</a> - <a href="https://www.openstreetmap.org" target="_blank" rel="noopener">&copy; OpenStreetMap</a> contributors'
      }).addTo(map);
      return;
    }

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      maxZoom: 19,
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
    }).addTo(map);
  }

  function pinIcon() {
    return L.divIcon({
      className: 'location-map__pin-wrap',
      html: '<svg class="location-map__pin" viewBox="0 0 24 32" xmlns="http://www.w3.org/2000/svg"><path fill="#F20102" stroke="#ffffff" stroke-width="1.5" d="M12 0C5.4 0 0 5.4 0 12c0 9 12 20 12 20s12-11 12-20c0-6.6-5.4-12-12-12z"/><circle cx="12" cy="12" r="5" fill="#ffffff"/></svg>',
      iconSize: [24, 32],
      iconAnchor: [12, 32],
      popupAnchor: [0, -30]
    });
  }

  function initLocationMap(mapEl) {
    if (mapEl.dataset.initialized === 'true') return;
    mapEl.dataset.initialized = 'true';

    var lat = parseFloat(mapEl.dataset.lat);
    var lng = parseFloat(mapEl.dataset.lng);
    if (isNaN(lat) || isNaN(lng)) return;
    var zoom = parseInt(mapEl.dataset.zoom, 10) || 14;

    var map = L.map(mapEl, { scrollWheelZoom: false }).setView([lat, lng], zoom);
    addTileLayer(map, mapEl.dataset.tileStyle, mapEl.dataset.jawgToken);

    var marker = L.marker([lat, lng], { icon: pinIcon() }).addTo(map);

    var title = mapEl.dataset.title || '';
    var address = mapEl.dataset.address || '';
    var directions = mapEl.dataset.directions ||
      ('https://www.google.com/maps/dir/?api=1&destination=' + encodeURIComponent(lat + ',' + lng));

    var parts = ['<div class="location-map__popup">'];
    if (title) parts.push('<strong>' + escapeHtml(title) + '</strong>');
    if (address) parts.push(escapeHtml(address) + '<br>');
    parts.push(
      '<a class="location-map__popup-directions" target="_blank" rel="noopener" href="' +
        escapeHtml(directions) +
        '">Get directions</a></div>'
    );

    marker.bindPopup(parts.join(''));
  }

  function init() {
    document.querySelectorAll('.location-map__map').forEach(initLocationMap);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
